import React from 'react'
import SupplierSupportContainer from '../../../../Components/SupportMessage/SupplierSupportContainer/SupplierSupportContainer'
import Layout from '../../Layout'

const SupplierSupport = () => {
  return (
    <Layout>
        <SupplierSupportContainer/>
    </Layout>
  )
}

export default SupplierSupport